export default "__VITE_ASSET__CDzwTSpz__"